import { EntityFields } from './entity';
import { ReadRequest, Request } from './request';
import { DataResponse, Response } from './response';
import { ValueAndDisplay } from './value-and-display';

export enum WorkflowInstanceFields {
  WorkflowKey = 'WorkflowKey',
  WorkflowStageKey = 'WorkflowStageKey',
  WorkflowTaskTemplateKey = 'WorkflowTaskTemplateKey',
  ParentKey = 'ParentKey',
  Completed = 'Completed',
  CreationDate = 'CreationDate',
  LastModifyDate = 'LastModifyDate',
  WithKey = 'WithKey',
}

export interface WorkflowInstance {
  [EntityFields.Key]: string | null;
  [WorkflowInstanceFields.WorkflowKey]?: string;
  [WorkflowInstanceFields.WorkflowStageKey]?: string | null;
  [WorkflowInstanceFields.WorkflowTaskTemplateKey]?: string;
  [WorkflowInstanceFields.ParentKey]?: string;
  [WorkflowInstanceFields.Completed]?: boolean;
  [WorkflowInstanceFields.CreationDate]?: ValueAndDisplay<string>;
  [WorkflowInstanceFields.LastModifyDate]?: ValueAndDisplay<string>;
  [WorkflowInstanceFields.WithKey]?: string;
}

export interface WorkflowInstanceReadRequest extends Request {
  WorkflowInstance: ReadRequest<WorkflowInstance>;
}

export interface WorkflowInstanceReadResponse extends Response {
  WorkflowInstance: DataResponse<WorkflowInstance>;
}
